import { render, staticRenderFns } from "./NewLicenseKind.vue?vue&type=template&id=7f4761a5&scoped=true"
import script from "./NewLicenseKind.vue?vue&type=script&lang=js"
export * from "./NewLicenseKind.vue?vue&type=script&lang=js"
import style0 from "./NewLicenseKind.vue?vue&type=style&index=0&id=7f4761a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4761a5",
  null
  
)

export default component.exports